import * as flowView from '../../flow/flow-view.js';

import * as withdrawServices from '../withdraw-services.js';

import playerServices from '../../account-info.js';

import * as cancelPendingWithdraw from './cancel-pending-withdraw.js';
import * as withdrawMethod from './withdraw-method.js';
import * as withdrawAmount from './withdraw-amount.js';

import * as paymentMethodData from './payment-method-data.js';

import * as history from '../../store/history.js';

import notifications from '../../notifications.js';

const mockContent = {
	contentContainer(title, color, nestedContent) {
		return `<div style="outline:2px solid ${color};">
				<h3>${title}</h3>
				${nestedContent}
			</div>`;
	}
};

function firstParent(element, tagName) {
	let el = {
		parentNode: element
	};
	while (el = el.parentNode) {
		if (el.tagName === tagName) {
			return el;
		}
	}
	return undefined;
}
const navigation = {
	navigationHandler(event) {
		const anchor = firstParent(event.target, 'A');

		if (anchor === undefined) {
			return;
		}

		const navAction = anchor.pathname[0] === '/' ? anchor.pathname.substr(1) : anchor.pathname;

		if (navigation[navAction]) {
			event.stopPropagation();
			event.preventDefault();
			navigation[navAction]();
		}
	},

	close: () => {
		initData.currentView = undefined;
		history.pushBack();
		notifications.hideConfirmationMessage();
	},
	show: (view) => {
		view = view || initData.currentView;
		initData.currentView = view;
		return navigation[initData.currentView].show();
	},
	back: (fromView) => {
		const current = navigation[fromView] || navigation[initData.currentView];
		if (current === undefined) {
			return navigation.close();
		}
		let currentOrdinal = -1;
		if (current && current.order > -1) {
			currentOrdinal = current.order;
		}

		const ordinal = currentOrdinal - 1;
		if (ordinal < 0) {
			return navigation.close();
		}

		const view = navigation.order[ordinal];
		return navigation[view].doShow()
			.then(showIt => {
				if (showIt) {
					return navigation.show(view);
				}
				return navigation.back(view);

			});
	},
	next: (fromView) => {
		const current = navigation[fromView] || navigation[initData.currentView];

		let currentOrdinal = -1;
		if (current && current.order > -1) {
			currentOrdinal = current.order;
		}

		const ordinal = currentOrdinal + 1;
		if (ordinal > navigation.order.length) {
			return navigation.close();
		}

		const view = navigation.order[ordinal];
		return navigation[view].doShow()
			.then(showIt => {
				if (showIt) {
					return navigation.show(view);
				}
				return navigation.next(view);

			});
	},

	cancelPending: {
		order: 0,
		preFetch: undefined,
		doShow: () => {
			return withdrawServices.fetchPendingWithdraws()
				.then(pendingWithdraws => {
					this.preFetch = pendingWithdraws;
					return pendingWithdraws.length > 0;
				});
		},
		show: () => {
			return routeHandlers.cancelPending(this.preFetch);
		}
	},
	method: {
		order: 1,
		doShow: () => {
			return Promise.resolve(true);
		},
		show: () => {
			return routeHandlers.method();
		}
	},
	amount: {
		order: 2,
		doShow: () => {
			return Promise.resolve(true);
		},
		show: () => {
			return routeHandlers.amount();
		}
	},

	order: ['cancelPending', 'method', 'amount'],
};

function flowViewDone(viewDone) {
	if (viewDone.status === 'reload') {
		return navigation.show();
	} else if (viewDone.status === 'back') {
		return navigation.back();
	} else if (viewDone.status === 'close') {
		return navigation.close();
	}
	return navigation.next();
}

const initData = {
	/* Mount point for withdraws, e.g. #/withdraw
	 * (It would be possible to add withdraw in many places, e.g. #/account/withdraw, #/casino/game/123/withdraw)
	 */
	contextPath: undefined,

	/* Context element for withdraw
	 * This could be different depending on what part of the application mounts withdraw)
	 */
	contextElement: undefined,
	/* Location before calling withdraw. Examples
	 * 		/casino
	 * 		/withdraw (previous /casino)
	 * 		/withdraw/cancel-pending (previous is still /casino)
	 * 		/account
	 * 		/withdraw (previous /account
	 */
	locationBeforeWithdraw: undefined,

	paymentFormDataServiceCachePromise: undefined,

	paymentMethodStore: undefined,

	currentView: undefined,

	verificationMessages: {
		mobileVerifyNotNow: '',
		mobileVerifyNow: '',
		mobileVerifyError: ''
	},

	withdrawConfig(contextPath, contextElement, lastPage) {
		this.contextPath = contextPath;
		this.contextElement = contextElement;
		this.locationBeforeWithdraw = lastPage;

		this.paymentFormDataServiceCachePromise = withdrawServices.preparePaymentFormDataServiceCache()
			.catch(e => {
				console.error('Failed call to withdrawServices.preparePaymentFormDataServiceCache()', e);
			});

		this.paymentMethodStore = paymentMethodData.createStore();

	},

	addNavigationHandlers(contextElement) {
		contextElement.addEventListener('click', navigation.navigationHandler, true);

	},

	initialize(contextPath, contextElementId, lastPage) {
		const contextElement = document.getElementById(contextElementId);
		if (contextElement === undefined) {
			throw new Error(`No such contextElement "${contextElementId}"`);
		}

		// Generic config for /withdraw
		this.withdrawConfig(contextPath, contextElement, lastPage);

		this.addNavigationHandlers(contextElement);

		const accMenuElement = document.querySelector('#js-account-menu');

		this.verificationMessages.mobileVerifyNotNow = accMenuElement.querySelector('#not-now').innerHTML;
		this.verificationMessages.mobileVerifyNow = accMenuElement.querySelector('#verify-now').innerHTML;
		this.verificationMessages.mobileVerifyError = accMenuElement.querySelector('#needs-verified-mobile').innerHTML;
	},
	cleanup() {
		this.contextPath = undefined;
		this.locationBeforeWithdraw = undefined;
		this.paymentFormDataServiceCachePromise = undefined;
		this.paymentMethodStore = undefined;
		this.currentView = undefined;

		const contextElement = this.contextElement;
		this.contextElement = undefined;

		if (contextElement) {
			contextElement.removeEventListener('click', navigation.navigationHandler);
			contextElement.classList.remove('withdrawal--open');
			contextElement.innerHTML = '';
		}
	}
};

function slideOutTransition(el) {
	return new Promise((resolve, reject) => {
		const OFF_CANVAS = 'u-hide-off-canvas';
		const OUT_DOWN = 'slide-out-down';
		const IN_UP = 'slide-in-up';
		const TRANSFORM_NONE = 'u-transform-none';

		if (el) {
			el.classList.remove(IN_UP);
			el.classList.remove(TRANSFORM_NONE);

			el.addEventListener('transitionend', () => {
				el.classList.add(OFF_CANVAS);
				resolve(el);
			}, false);

			el.classList.add(OUT_DOWN);
		}
		resolve(undefined);
	});
}
function slideInTransition(el) {
	return new Promise((resolve, reject) => {
		const OFF_CANVAS = 'u-hide-off-canvas';
		const OUT_DOWN = 'slide-out-down';
		const IN_UP = 'slide-in-up';
		const TRANSFORM_NONE = 'u-transform-none';

		if (el) {
			el.classList.remove(OUT_DOWN);
			el.classList.remove(OFF_CANVAS);

			el.addEventListener('transitionend', () => {
				resolve(el);
			}, false);

			el.classList.add(IN_UP);
			el.classList.add(TRANSFORM_NONE);
		}
		resolve(undefined);
	});
}
function removeIfExists(element) {
	if (element) {
		return slideOutTransition(element)
			.then((elAfterAnimation) => {
				const el = elAfterAnimation;
				if (el && el.parentNode && el.parentNode.removeChild) {
					el.parentNode.removeChild(el);
				}
			});
	}
	return Promise.resolve(undefined);
}

function addNewViewAndRemoveOld(contextElement, content) {
	const doc = contextElement.ownerDocument;
	const FLOW_VIEW_CONTENT_ID = 'flow-content-element';


	const oldFlowDiv = doc.getElementById(FLOW_VIEW_CONTENT_ID);
	return removeIfExists(oldFlowDiv)
		.then(() => {
			contextElement.innerHTML = content;
			const newFlowDiv = doc.getElementById(FLOW_VIEW_CONTENT_ID);
			return slideInTransition(newFlowDiv);
		});
}
function display(contextElement, content) {
	contextElement.classList.add('withdrawal--open');
	return addNewViewAndRemoveOld(contextElement, content);
}


const views = {
	getPendingWithdrawFlowView(contextPath, pendingWithdrawContent) {
		const buttons = flowView.setButtonConfig(['back']);
		const context = {
			path: contextPath,
			content: pendingWithdrawContent.html
		};
		return flowView.flowView(pendingWithdrawContent.title, buttons, context);
	},
	getWithdrawMethodFlowView(contextPath, methodSelectorContent) {
		const buttons = flowView.setButtonConfig(['back']);
		const context = {
			path: contextPath,
			content: methodSelectorContent.html
		};
		return flowView.flowView(methodSelectorContent.title, buttons, context);
	},
	getWithdrawAmountView(contextPath, amountContent) {
		const buttons = flowView.setButtonConfig(['back']);
		const context = {
			path: contextPath,
			content: amountContent.html
		};

		return flowView.flowView(amountContent.title, buttons, context);
	},
};

const verification = {
	fetchPlayerInfo() {
		return playerServices.fetchPlayerInfo()
			.then(playerInfoResult => playerInfoResult.result);
	},
	isMobileVerificationOk() {
		return withdrawServices.isMobileVerifyNeeded();
	},
	getMobileVerificationView(playerInfo) {

		const mockVerify = mockContent.contentContainer('Mobile Verification Needed', 'blue',
			`You must first verify mobile number ${playerInfo.mobileCountryCode} ${playerInfo.mobile}`);

		const title = 'Mobile Verification Needed';
		const buttons = flowView.setButtonConfig(['back']);
		const context = {
			path: initData.contextPath,
			content: mockVerify
		};
		return flowView.flowView(title, buttons, context);
	},
	mobileVerifyHandler(path) {
		return this.fetchPlayerInfo()
			.then(this.getMobileVerificationView);
	}
};

const preConditions = {
	shouldVerifyMobile() {
		return verification.isMobileVerificationOk();
	}
};

const routeHandlers = {
	verifyMobile: () => {
		const pushToMobileVerify = function () {
			history.push('/account/mysettings/verify-mobile/', { referrer: 'withdraw' });
		};
		const pushToAccount = function () {
			notifications.hideNotification();
			history.push('/account/');
		};
		notifications.showBinaryQuestion(initData.verificationMessages.mobileVerifyError,
										initData.verificationMessages.mobileVerifyNow,
										initData.verificationMessages.mobileVerifyNotNow, pushToMobileVerify, pushToAccount);
	},
	cancelPending: (pendingWithdraws) => {
		cancelPendingWithdraw.getPendingWithdrawContent(pendingWithdraws)
			.then(withdrawContent => {
				return views.getPendingWithdrawFlowView(initData.contextPath, withdrawContent);
			})
			.then(flowContent => {
				display(initData.contextElement, flowContent);
			});
	},
	method: () => {
		let viewReadyPromiseResolver;
		const viewReadyPromise = new Promise((resolve) => {
			viewReadyPromiseResolver = resolve;
		});
		return withdrawMethod.withdrawMethodView(initData.contextPath, initData.paymentMethodStore, viewReadyPromise)
			.then(withdrawMethodView => {
				views.getWithdrawMethodFlowView(initData.contextPath, withdrawMethodView)
					.then(withdrawMethodFlowContent => {
						display(initData.contextElement, withdrawMethodFlowContent)
							.then(() => {
								return viewReadyPromiseResolver(initData.contextElement);
							});
					});
				return withdrawMethodView.viewDonePromise;
			})
			.then(flowViewDone);
	},
	amount: () => {
		const selectedMethod = initData.paymentMethodStore.getMethod();
		if (selectedMethod === undefined) {
			routeHandlers.gotoFlowView('method');
		}
		let viewReadyPromiseResolver;
		const viewReadyPromise = new Promise((resolve) => {
			viewReadyPromiseResolver = resolve;
		});

		return withdrawAmount.withdrawAmountView(initData.contextPath, initData.paymentMethodStore, viewReadyPromise)
			.then(amountView => {
				views.getWithdrawAmountView(initData.contextPath, amountView)
					.then(flowViewHtml => {
						display(initData.contextElement, flowViewHtml)
							.then(() => {
								viewReadyPromiseResolver(initData.contextElement);
							});
					});

				return amountView.viewDonePromise;
			})
			.then(flowViewDone);
	}
};

function init(contextPath, contextElementId) {
	initData.initialize(contextPath, contextElementId);
}
function cleanup() {
	initData.cleanup();
}

function withdrawFlow() {
	preConditions.shouldVerifyMobile()
		.then(response => {
			if (!response.verifyMobile) {
				return navigation.next();
			}
			return routeHandlers.verifyMobile();
		});
}

export {
	init,
	withdrawFlow,
	cleanup
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/withdraw/withdraw-controller.js